import { useUnistyles } from 'react-native-unistyles';
import { FONT } from '../constants';

export default function BranchChip({ label, isDefault }) {
    const { theme } = useUnistyles();
    const color = isDefault ? theme.colors.textSecondary : theme.colors.warning;
    const bg = isDefault ? theme.colors.surfaceVariant : theme.colors.warningContainer;

    return (
        <span style={{
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: 20,
            backgroundColor: bg,
            border: `1px solid ${color}`,
            color,
            fontSize: 11,
            fontWeight: 600,
            fontFamily: FONT,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            boxSizing: 'border-box',
        }}>
            {label}
        </span>
    );
}
